module.exports = __webpack_public_path__ + "img/banner_product.a731d958.jpg";